import { CustomAdUnitConfig } from '@/types'

const COMMON_CAMPAIGN_ID = 'portal-export-fallback'

export const PORTAL_BANNERS_FALLBACK_CONFIG: CustomAdUnitConfig[] = [
    {
        platforms: ['desktop'],
        campaignId: COMMON_CAMPAIGN_ID,
        creatives: [
            {
                name: 'tb-world',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'a894bcc6-d4cb-4869-d09c-5c142a3cf400',
                clickUrl: 'https://playgama.com/game/tb-world?utm_source=gam_fallback',
                width: 540,
                height: 300,
            },
            {
                name: 'playground-man-ragdoll-show',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'cdeb2791-7471-456f-ef52-694290f48000',
                clickUrl: 'https://playgama.com/game/playground-man-ragdoll-show?utm_source=gam_fallback',
                width: 540,
                height: 300,
            },
            {
                name: 'gangster-island-crime-city',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'ce93059a-dfa2-4e3c-2e6e-c6a0e4180900',
                clickUrl: 'https://playgama.com/game/gangster-island-crime-city?utm_source=gam_fallback',
                width: 540,
                height: 300,
            },
            {
                name: 'piece-of-cake-merge--bake',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: '23a90036-7be5-4f32-c34f-c83c7158b900',
                clickUrl: 'https://playgama.com/game/piece-of-cake-merge--bake?utm_source=gam_fallback',
                width: 540,
                height: 300,
            },
            {
                name: 'vega-mix-2-adventure',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: '7c110a82-bb25-429a-2be8-7692a60e7c00',
                clickUrl: 'https://playgama.com/game/vega-mix-2-adventure?utm_source=gam_fallback',
                width: 540,
                height: 300,
            },
        ],
    },
    {
        platforms: ['ios'],
        campaignId: COMMON_CAMPAIGN_ID,
        creatives: [
            {
                name: 'tb-world',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'e626ee2d-7ed8-41f9-07c6-4d4111f41a00',
                supportedOrientations: ['portrait'],
                clickUrl: 'https://playgama.com/game/tb-world?utm_source=gam_fallback',
                width: 300,
                height: 300,
            },
            {
                name: 'gangster-island-crime-city',
                adUnits: ['interstitial', 'rewarded'],
                supportedOrientations: ['portrait'],
                format: 'banner',
                file: '34e0500a-aecd-4cf4-f5af-30433f272d00',
                clickUrl: 'https://playgama.com/game/gangster-island-crime-city?utm_source=gam_fallback',
                width: 300,
                height: 300,
            },
            {
                name: 'piece-of-cake-merge--bake',
                adUnits: ['interstitial', 'rewarded'],
                supportedOrientations: ['portrait'],
                format: 'banner',
                file: '06937377-1d70-40ae-9633-8d7a01b6fd00',
                clickUrl: 'https://playgama.com/game/piece-of-cake-merge--bake?utm_source=gam_fallback',
                width: 300,
                height: 300,
            },
        ],
    },
    {
        platforms: ['android'],
        campaignId: COMMON_CAMPAIGN_ID,
        creatives: [
            {
                name: 'tb-world',
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: 'e626ee2d-7ed8-41f9-07c6-4d4111f41a00',
                supportedOrientations: ['portrait'],
                clickUrl: 'https://playgama.com/game/tb-world?utm_source=gam_fallback',
                width: 300,
                height: 300,
            },
            {
                name: 'gangster-island-crime-city',
                adUnits: ['interstitial', 'rewarded'],
                supportedOrientations: ['portrait'],
                format: 'banner',
                file: '34e0500a-aecd-4cf4-f5af-30433f272d00',
                clickUrl: 'https://playgama.com/game/gangster-island-crime-city?utm_source=gam_fallback',
                width: 300,
                height: 300,
            },
            {
                name: 'piece-of-cake-merge--bake',
                adUnits: ['interstitial', 'rewarded'],
                supportedOrientations: ['portrait'],
                format: 'banner',
                file: '06937377-1d70-40ae-9633-8d7a01b6fd00',
                clickUrl: 'https://playgama.com/game/piece-of-cake-merge--bake?utm_source=gam_fallback',
                width: 300,
                height: 300,
            },
            {
                name: 'vega-mix-2-adventure',
                supportedOrientations: ['portrait'],
                adUnits: ['interstitial', 'rewarded'],
                format: 'banner',
                file: '7c312346-aa30-4aab-5821-9d8b2e746c00',
                clickUrl: 'https://playgama.com/game/vega-mix-2-adventure?utm_source=gam_fallback',
                width: 300,
                height: 300,
            },
            {
                name: 'playground-man-ragdoll-show',
                adUnits: ['interstitial', 'rewarded'],
                supportedOrientations: ['portrait'],
                format: 'banner',
                file: '745165fa-bd9a-4245-43e3-abdfa0cde500',
                clickUrl: 'https://playgama.com/game/playground-man-ragdoll-show?utm_source=gam_fallback',
                width: 300,
                height: 300,
            },
        ],
    },
]
